<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-10 15:42:35
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:38:25
-->
<template>
  <div class="innovative innovative-aneuplan" :class="{textj: language != 'en'}">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneuplan.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-120" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="m-t-12" :src="$t('product.aneuplan.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-40">
            <div class="innovative-item-title" v-html="$t('product.aneuplan.list[0].title')"></div>
            <div class="p-t-46 p-b-30 textj">
              <p v-for="item, index in $t('product.aneuplan.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel aneuplan-characteristics">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.aneuplan.list[1].imgBj')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="{posabs: language != 'en'}">
          <div class="innovative-characteristics flex align_items_center justify_content_between">
            <div class="trans-list" :class="language == 'en' ? 'flex_auto' : 'flex_2'">
              <div class="innovative-item-title" v-html="$t('product.aneuplan.list[1].title')"></div>
              <div class="p-t-24">
                <div :class="index == 1 ? 'p-t-30' : ''" v-for="item, index in $t('product.aneuplan.list[1].des')" :key="index">
                  <div class="innovative-wrap-item-title p-b-10" v-html="item.title"></div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </div>
            <div class="p-l-40" :class="language == 'en' ? '' : 'flex_3'">
              <img class="" :src="$t('product.aneuplan.list[1].img')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-container">
        <div ref="box4" class="innovative-wrap-item p-t-98 article">
          <div class="innovative-item-title" v-html="$t('product.aneuplan.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.aneuplan.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  },
  methods: {}
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-aneuplan {
  padding-bottom: 50PX;
  .innovative-characteristics {
    padding: 0 75PX;
  }
}
.pc.en .innovative-aneuplan {
  .innovative-characteristics {
    padding: 0 60PX;
    img {
      width: auto;
      max-height: 90%;
    }
  }
  .aneuplan-characteristics {
    background-image: url('~@/assets/images/innovate/AneuPlan/3.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    .innovative-characteristics {
      padding: 50PX 60PX;
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1500PX) {
  .pc.zh .innovative-aneuplan {
    .aneuplan-characteristics {
      height: 570PX;
    }
  }
}
@media screen and (max-width: 1400PX) {
  .pc.zh .innovative-aneuplan {
    .aneuplan-characteristics {
      height: 680PX;
    }
  }
}
@media screen and (max-width: 1440PX) and (max-height: 900PX) {
  .pc.zh .innovative-aneuplan {
    .aneuplan-characteristics {
      height: 680PX;
    }
  }
}
</style>
